import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal, openModals } from "../../redux/modal.slice";
import ModalsEnum from "../../enums/modal.enum";
import Input from "../../components/Input";
import Button from "../../components/Buttons/button";
import { ArrowNarrowLeft } from "@untitledui/icons/ArrowNarrowLeft";
import { Key01 } from "@untitledui/icons/Key01";
import { forgotPassword_req } from "../../api/profiles.api";

const ResetPasswordModal = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const backToLogin = () => {
    dispatch(closeModal({}));

    dispatch(
      openModals({
        modalIds: [ModalsEnum.SIGN_IN_MODAL],
      })
    );
  };

  const handleChange = (e) => {
    setEmail(e?.target?.value);
  };

  const forgotPassword = async () => {
    try {
      await forgotPassword_req(email);
      setError("");
      dispatch(
        openModals({
          modalIds: [ModalsEnum.CHECK_EMAIL_MODAL],
          modalData: {
            className: "check-email-modal",
            email: [email],
          },
        })
      );
    } catch (e) {
      console.log("e", e);
      setError(e?.response?.data?.error);
    }
  };

  return (
    <>
      <div className="modal-header text-center">
        <div className="icon purple">
          <Key01 />
        </div>
        <h4 className="mb-8">Reset your password</h4>
        <p className="text-color-grey">
          Enter the email linked to your account. We’ll send you a link to
          create a new password.
        </p>
      </div>

      <div className="modal-body">
        <Input
          id={"email"}
          label={"Email"}
          placeholder={"Enter your email"}
          name={"email"}
          type={"email"}
          value={email}
          onChange={handleChange}
          className="mb-32"
          error={error ? true : false}
          errorMessage={error}
        />
        <Button
          text={"Reset Password"}
          fullWidth={true}
          onClick={forgotPassword}
        />

        <button
          className="back-login-button flex flex-align-center flex-justify-center text-color-grey"
          onClick={backToLogin}
        >
          <ArrowNarrowLeft
            color={"#475467"}
            className={"mr-8"}
          />
          Back to Log In
        </button>
      </div>
    </>
  );
};

export default ResetPasswordModal;
